module.exports = __webpack_public_path__ + "a1bbbfa8cbe2b2d5f8d016be31a20ed9.png";